export enum MixPanelEventName {
    ADD_NEW_PRODUCT = "add_new_product",
    PRODUCT_CLICK = "product_click",
    ADD_PRODUCT_CLICK = "add_product_click",
    EDIT_BULK_PRODUCT_CLICK = "edit_bulk_product_click",
    DOWNLOAD_TEMPLATE_FILE = "download_template_file",
    UPLOAD_FILE_NAME = "upload_file_name",
    PRODUCT_SHARE_CLICK = "product_share_click",
    UPDATE_PRODUCT_CLICK = "update_product_click",
    PRODUCT_DELETE_CLICK = "product_delete_click",
    NEW_VARIANT_CLICK = "new_variant_click",
    ADD_BULK_PRODUCT_CLICK = "add_bulk_product_click",
    STORE_NAME = "store_name",
    STORE_DETAILS = "store_details",
    FAQ_CLICK = "faq_click",
    HOW_TO_GUIDE_CLICK = "how_to_guid_click",
    SHARE_STORE_BUTTON_CLICK = "share_store_click",
    SHARE_STORE_LINK = "share_store_url_click",
    CATALOG_UPDATE_ERROR = "catelog_update_error_click",
    BULK_ACTION_CLICK = "bulk_actions_click",
    CONTINUE = "continue",
    SHARE_WHATSAPP_CLICK = "share_product_whatsapp_click",
    SHARE_FACEBOOK_CLICK = "share_product_facebook_click",
    SHARE_X_CLICK = "share_product_x_click",
    SHARE_MAIL_CLICK = "share_product_mail_click",
    SHARE_STORE_WHATSAPP_CLICK = "share_store_whatsapp_click",
    SHARE_STORE_FACEBOOK_CLICK = "share_store_facebook_click",
    SHARE_STORE_MAIL_CLICK = "share_store_mail_click",
    SHARE_STORE_X_CLICK = "share_store_x_click",
    CHAT_WITH_US = "chat_with_us",
    HOME_URL_VISIT = "home_url_visit",
    VALID_TOKEN = "valid_token",
    EMAIL_MISSING = "email_missing_onboarding",
    MOBILE_MISSING = "mobile_missing_onboarding",
    LOGIN = "login",
    AUTH_PAGE_VISIT = "auth_page_visit"
}